module.exports = __webpack_public_path__ + "static/media/puzzle09.289b4ace.png";